import { Box, Flex, Text, Button, Icon } from '@chakra-ui/react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'helpers/languages/translations';
import { FC } from 'react';
import icons from 'shared/icons';

const MFileLinkUpload: FC<{ handleChangeFile: (file: File | null) => void; isDisabled?: boolean }> = ({
    handleChangeFile,
    isDisabled,
}) => {
    const translate = useTranslation();
    const UploadIcon = icons.upload;

    const onDrop = (acceptedFiles: File[]) => {
        const file = acceptedFiles[0];
        handleChangeFile(file);
    };

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop,
        maxFiles: 1,
        noClick: true,
    });

    return (
        <Box>
            <Flex {...getRootProps({})}>
                <input {...getInputProps()} />
                <Box m={0} {...getRootProps({ className: 'dropzone' })}>
                    <Button onClick={open} size="sm" rightIcon={<Icon as={UploadIcon} />} isDisabled={isDisabled}>
                        Upload file
                    </Button>
                </Box>
            </Flex>
        </Box>
    );
};

export default MFileLinkUpload;
